import { Card, Row, Col } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { getApi } from '../api/endpoints';

const StatesStats = () => {
  const [statesApi] = getApi('states');
  const [stateCount, setStateCount] = useState(0);

  useEffect(() => {
    fetchStates();
  }, [])

  const fetchStates = async () => {
    try {
      const response = await statesApi({ fields: 'options' }).unwrap();
      setStateCount(response.data.states.length);
    } catch (error) {
    }
  }

  return <div className="states-stats mb-3">
    <Row>
      <Col lg={{ span: 2 }} className='mb-2'>
        <Card className='shadow'>
          <Card.Body>
            <Card.Title>Total States</Card.Title>
            <Card.Text>
              {stateCount}
            </Card.Text>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
}

export default StatesStats;
